module.exports = __webpack_public_path__ + "img/2.70abd13a.png";